import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'stripTags',
    pure: false,
    standalone: false
})
export class StripTagsPipe implements PipeTransform {

  transform(items: any) {
    const data = [];
    items.map(value => {
      data.push(value.replace(/(title=')([a-zA-Z0-9:;%&#@\/\\.\s\(\)\-\,]*)(')/gi, ''));
    });
      return data;
  }

}
